import React, { Component } from 'react';
import logo from './images/logo.svg';
import './App.css';
import './Header.css';
import { Link } from 'react-router-dom'

class Header extends Component {
  render() {
    return (
      <header>
        <div id="navigation">
          <div className="container">
            <ul>
              <li className="logo"><Link to='/'><img src={logo} alt="Zygous Labs"/></Link></li>
              <li className="hideOnMobile"><Link to='/partner'>Partner</Link></li>
              <li className="hideOnMobile"><a href="mailto:info@zygouslabs.com?Subject=Press%20Inquiry">Press Inquiries</a></li>
              <li className="signUp"><Link to='/signup'>Sign Up</Link></li>
            </ul>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js